import React, { useEffect, useLayoutEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import {
  getFollowupLead,
  getInsentiveType,
} from "reduxStore/action/masterActions";
import { propertyFormUpdate } from "reduxStore/action/propertyActions";
import { getUserFilterDetail } from "reduxStore/action/usersActions";
import { parentUserList } from "reduxStore/action/usersActions";
import { getRoleList } from "reduxStore/action/roleActions";
import strings from "translate/language";
import {
  handleListResponse,
  seo,
  ValidateExtensionImgeVideo,
} from "../../utils/utils";
import Breadcrumb from "component/common/breadcrumb";
import {
  ChannelPartner,
  ClosingManager,
  ClosingTL,
  CPAgent,
  HR,
  propertyrole,
  SourcingManager,
  SourcingTL,
  SubAdmin,
} from "utils/constants";
import Button from "../../component/Button";
import { Gallery, Item } from "react-photoswipe-gallery";
import VideoModel from "component/common/videoModel";
import { propertyDocumentDelete } from "../../reduxStore/action/propertyActions";
import { PROPERTY_DOCUMENT_DELETE } from "../../reduxStore/types";

const EditPropertyNext = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const params = useParams();
  const { property_id = "" } = params || {};
  const [allocationAddMore, setAllocationAddMore] = useState(true);
  const [uploadFields, setUploadFields] = useState([{ file: "" }]);
  const [propertyDoc, setPropertyDoc] = useState([]);
  const [videoDetails, setVideoDetails] = useState(null);
  const [docType, setDocType] = useState({});
  const [formState, setFormState] = useState({});
  const [formVaild, setFormVaild] = useState({});
  const [userList, setUserList] = useState([]);
  const [leadFollowUp, setLeadFollowUp] = useState([]);
  const [rolesList, setRolesList] = useState(propertyrole);
  const [insentiveTypes, setInsentiveTypes] = useState([]);
  const [ParentUserList, setParentUserList] = useState([]);
  // Allocation_clone
  const [propertyAllocation, setPropertyAllocation] = useState([
    { role_id: "", users: [], selectedUsers: [] },
  ]);
  const [propertyFields, setPropertyFields] = useState([{ property_name: "" }]);
  // insetive_clone
  const [insetiveState, setInsetive] = useState([
    { insentive_type_id: "", amount: "" },
  ]);
  const propertyFormSelector = useSelector((state) => state.propertyForm) || {};
  const insentiveTypesSelector =
    useSelector((state) => state.insentiveTypes) || {};
  const userListSelector = useSelector((state) => state.userData);
  const propertySelector = useSelector((state) => state.propertyData);
  const followUpSelector = useSelector((state) => state.followUpMaster);
  const getRoleListSelector = useSelector((state) => state.roleData) || {};

  useEffect(() => {
    dispatch(getFollowupLead());
    dispatch(getInsentiveType());
    dispatch(getRoleList());
  }, []);

  useEffect(() => {
    if (
      propertyAllocation[0].selectedUsers.length === 0 ||
      !propertyAllocation[0].role_id
    ) {
      setAllocationAddMore(true);
    } else {
      if (
        propertyAllocation.some(
          (i) => i.selectedUsers.length === 0 || i.role_id === ""
        )
      ) {
        setAllocationAddMore(true);
      } else if (
        propertyAllocation.some(
          (i) => i.selectedUsers.length === 1 || i.role_id != ""
        )
      ) {
        setAllocationAddMore(false);
      }
    }
  }, [propertyAllocation]);

  useLayoutEffect(() => {
    if (propertyFormSelector.update && propertyFormSelector?.response) {
      const {
        competitor_property = [],
        property_allocation = [],
        insentive = [],
        property_allocateds,
        property_insentives,
        property_competitors,
        property_document,
      } = propertyFormSelector?.response;
      setFormState(propertyFormSelector?.response);
      if (property_document.length > 0) {
        setPropertyDoc(property_document);
        // let files = property_document.map((i) => ({
        //   file: i.document,
        // }));
        // setUploadFields([...uploadFields, files]);
      }
      let propertyAllocationArr, insentiveArr, propertyFieldsArr;
      if (property_competitors?.length > 0) {
        propertyFieldsArr = property_competitors.map((i) => ({
          property_name: i.competitor_name,
        }));
      } else {
        if (competitor_property?.length > 0) {
          propertyFieldsArr = competitor_property;
        } else {
          propertyFieldsArr = propertyFields;
        }
      }
      setPropertyFields(propertyFieldsArr);
      if (property_allocateds?.length > 0) {
        property_allocateds.map((i) => {
          dispatch(
            getUserFilterDetail({
              offset: 0,
              role_id: i?.role_id,
            })
          );
          if (
            i.users.length > 0 &&
            (i.role_id === SourcingTL || i.role_id === ClosingTL)
          ) {
            dispatch(
              parentUserList({
                role_id: i.role_id,
                user_id: i.users.map((u) => u?._id),
                isLoadMore: true,
              })
            );
          }
        });
        propertyAllocationArr = property_allocateds.map((i) => ({
          role_id: i?.role_id,
          users: i.users.map((u) => u?._id),
          selectedUsers: i.users.map((u) => {
            if (u?._id) {
              u._id = u?._id;
            }
            return u;
          }),
        }));
      } else {
        if (property_allocation?.length > 0) {
          propertyAllocationArr = property_allocation;
        } else {
          propertyAllocationArr = propertyAllocation;
        }
      }
      setPropertyAllocation(propertyAllocationArr);
      if (property_insentives?.length > 0) {
        insentiveArr = property_insentives;
      } else {
        if (insentive.length > 0) {
          insentiveArr = insentive;
        } else {
          insentiveArr = insetiveState;
        }
      }
      setInsetive(insentiveArr);
    }
  }, []);

  useEffect(() => {
    const { response } = getRoleListSelector;
    if (response) {
      if (response?.status === 200) {
        let filterData = handleListResponse(response.data).filter(
          (i) =>
            // i._id !== SourcingManager &&
            // i._id !== ClosingManager &&
            i._id !== CPAgent &&
            i._id !== ChannelPartner &&
            i._id !== SubAdmin &&
            i._id !== HR
        );
        setRolesList(filterData);
      } else {
        setRolesList([]);
      }
    }
  }, [getRoleListSelector]);

  useEffect(() => {
    const { userData, parentUsers } = userListSelector;
    if (userData) {
      const { userData } = userListSelector;
      if (userData?.status === 200) {
        setUserList((prev) =>
          Array.from(
            [...prev, ...handleListResponse(userData?.data)]
              .reduce((m, o) => m.set(o._id, o), new Map())
              .values()
          )
        );
      }
      if (parentUsers) {
        setParentUserList((prev) =>
          Array.from(
            [...prev, ...handleListResponse(parentUsers?.data)]
              .reduce((m, o) => m.set(o._id, o), new Map())
              .values()
          )
        );
      }
    }
  }, [userListSelector]);

  useEffect(() => {
    if (insentiveTypesSelector.response) {
      const { response } = insentiveTypesSelector;
      if (response?.status === 200) {
        setInsentiveTypes(handleListResponse(response.data));
      } else {
        setInsentiveTypes([]);
      }
    }
  }, [insentiveTypesSelector]);
  useEffect(() => {
    if (followUpSelector?.response) {
      const { response } = followUpSelector;
      if (response?.status === 200) {
        setLeadFollowUp(handleListResponse(response?.data));
      } else {
        setLeadFollowUp([]);
      }
    }
  }, [followUpSelector]);

  useEffect(() => {
    if (propertySelector?.deleteResponse) {
      const { deleteResponse } = propertySelector;
      if (deleteResponse?.status === 200) {
        let data = propertyDoc.filter(
          (e) => String(e.document) !== String(docType.documentId)
        );
        if (data.length > 0) {
          setPropertyDoc(data);
          setDocType({});
          formState.property_document = data;
          dispatch(propertyFormUpdate(formState));
          dispatch({ type: PROPERTY_DOCUMENT_DELETE, payload: null });
        }
      }
    }
  }, [propertySelector]);

  const navigatpage = async (navname) => {
    navigate(navname);
  };

  const handleSelectMultiAllocation = (index, value) => {
    let data = [...propertyAllocation];
    data[index]["selectedUsers"] = value;
    data[index]["users"] = value.map((i) => i._id);
    setPropertyAllocation(data);
    if (
      data[index]["users"].length > 0 &&
      (data[index].role_id === SourcingTL || data[index].role_id === ClosingTL)
    ) {
      dispatch(
        parentUserList({
          role_id: data[index].role_id,
          user_id: data[index]["users"],
          isLoadMore: true,
        })
      );
    }
  };

  const handleManager = (result, value) => {
    let newSelectField = {
      role_id: value,
      users: [],
      selectedUsers: [],
    };

    setAllocationAddMore(true);
    return [...result, newSelectField];
  };
  const handleChangeAllocation = (index, event) => {
    let data = [...propertyAllocation];
    data[index][event.target.name] = event.target.value;
    data[index]["selectedUsers"] = [];
    data[index]["users"] = [];
    if (event.target.value !== strings.selectRole) {
      // if (event.target.value === SourcingTL) {
      //   data = handleManager(data, SourcingManager);
      // } else if (event.target.value === ClosingTL) {
      //   data = handleManager(data, ClosingManager);
      // }
      let obj = { [SourcingManager]: SourcingTL, [ClosingManager]: ClosingTL };
      if (obj[event.target.value]) {
        const managerData = data.filter(
          (so) => so.role_id === obj[event.target.value]
        );
        if (managerData.length > 0) {
          dispatch(
            parentUserList({
              role_id: managerData[0].role_id,
              user_id: managerData[0]["users"],
              isLoadMore: true,
            })
          );
        }
      } else {
        dispatch(
          getUserFilterDetail({ offset: 0, role_id: event.target.value })
        );
      }
    }
    setPropertyAllocation(data);
  };

  // const loadOptions = async (search, prevOptions) => {
  //   let limit = 10;
  //   let offset = prevOptions.length*1;
  //   const hasMore = userList.length > prevOptions.length + 10;
  //   dispatch(
  //     getUserFilterDetail({
  //       limit: limit,
  //       offset: offset,
  //       role_id: role_id,
  //     })
  //   );

  //   return {
  //     options: userList,
  //     hasMore,
  //   };
  // };

  const handleInsetiveState = (index, event) => {
    let data = [...insetiveState];
    data[index][event.target.name] = event.target.value;
    setInsetive(data);
  };

  const addUploadFields = () => {
    let newUploadField = { file: "" };
    setUploadFields([...uploadFields, newUploadField]);
  };

  const removeFields = (index) => {
    let data = [...uploadFields];
    data.splice(index, 1);
    setUploadFields(data);
  };

  const removeField = (index) => {
    let data = [...propertyAllocation];
    data.splice(index, 1);
    setPropertyAllocation(data);
  };

  const removeInsentive = (index) => {
    let data = [...insetiveState];
    data.splice(index, 1);
    setInsetive(data);
  };

  const PropertyhandleChange = (index, event) => {
    let data = [...propertyFields];
    data[index][event.target.name] = event.target.value;
    setPropertyFields(data);
  };

  const addPropertyFields = () => {
    let newPropertyField = { property_name: "" };
    setPropertyFields([...propertyFields, newPropertyField]);
  };

  const removePropertyFields = (index) => {
    let data = [...propertyFields];
    data.splice(index, 1);
    setPropertyFields(data);
  };

  const addSelectFields = () => {
    let newSelectField = { role_id: "", users: [], selectedUsers: [] };
    setAllocationAddMore(true);
    setPropertyAllocation([...propertyAllocation, newSelectField]);
  };

  const addInsetiveState = () => {
    let newSelectField = { insentive_type_id: "", amount: "" };
    setInsetive([...insetiveState, newSelectField]);
  };
  const handleInputField = (e) => {
    const nextFormState = {
      ...formState,
      [e.target.name]: e.target.value,
    };
    setFormState(nextFormState);
  };

  const handleDeleteDocument = () => {
    dispatch(
      propertyDocumentDelete({
        property_id: property_id,
        document: docType?.documentId,
      })
    );
  };

  const handleSubmit = () => {
    if (!handleValid()) {
      if (formState.amenity) {
        formState.amenity = formState?.amenity.map((i) => {
          i["amenity_id"] = i._id;
          return i;
        });
      }
      formState.property_image = uploadFields.map((i) => i.file);
      formState.competitor_property = propertyFields;
      formState.property_allocation = propertyAllocation;
      formState.insentive = insetiveState;
      dispatch(propertyFormUpdate(formState));

      // dispatch(editProperty(formData));
      navigatpage("/editpropertystepthird/" + property_id);
    }
  };
  const handleValid = () => {
    let err = {};
    let formError = false;
    // if (!uploadFields[0].file) {
    //   formError = true;
    //   err["uploadFields"] = strings.propertyImgErr;
    // }
    // if (!formState.lead_followup) {
    //   formError = true;
    //   err["lead_followup"] = strings.leadfollowupErr;
    // }
    // if (formState.lead_followup === strings.selectlead) {
    //   formError = true;
    //   err["lead_followup"] = strings.leadfollowupErr;
    // }
    if (!propertyAllocation[0].role_id) {
      formError = true;
      err["selectRole"] = strings.selectRoleErr;
    }
    if (propertyAllocation[0].selectedUsers.length === 0) {
      formError = true;
      err["selectUser"] = strings.selectUserErr;
    }
    // if (!propertyFields[0].property_name) {
    //   formError = true;
    //   err["property_name"] = strings.propertynameErr;
    // }
    // if (!insetiveState[0].insentive_type_id) {
    //   formError = true;
    //   err["insentive_type_id"] = strings.insentiveErr;
    // }
    // if (!insetiveState[0].insentive_type_id) {
    //   formError = true;
    //   err["insentive_type_id"] = strings.insentiveErr;
    // }
    // if (insetiveState[0].insentive_type_id === strings.selectType) {
    //   formError = true;
    //   err["insentive_type_id"] = strings.insentiveErr;
    // }
    // if (!insetiveState[0].amount) {
    //   formError = true;
    //   err["amount"] = strings.amountErr;
    // }
    // if (isNaN(insetiveState[0].amount)) {
    //   formError = true;
    //   err["amount"] = strings.validAmount;
    // }
    setFormVaild(err);
    return formError;
  };
  useEffect(() => {
    seo({
      title: "Edit Property",
      metaDescription: "edit property details",
      canonicalLink: window.location.href,
    });
  }, []);

  let deleteTitle = {
    image: strings.imageItem,
    video: strings.videoItem,
    document: strings.docItem,
  };
  return (
    <div className="page-body">
      {/* Model_start */}
      <div
        className="modal fade"
        id="exampleModal1"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                {strings.delete} {deleteTitle[docType?.type]}
              </h5>
              <button
                className="close"
                type="button"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="text-center">
                <h6>{strings.areYouSure}</h6>
              </div>
              <div className="text-center">
                <h6>
                  {strings.youWantDelete} {deleteTitle[docType?.type]}
                  {" !"}
                </h6>
              </div>
            </div>
            <div className="modal-footer justify-content-center">
              <button
                className="btn btn-success mr-5"
                type="button"
                onClick={() => handleDeleteDocument()}
                data-dismiss="modal"
              >
                {strings.yes}
              </button>
              <button
                className="btn btn-primary"
                type="button"
                onClick={() => setDocType({})}
                data-dismiss="modal"
              >
                {strings.no}
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* Model_end */}
      <VideoModel data={videoDetails} />
      <Breadcrumb
        title={strings.editProperty}
        url={"/property"}
        parentListing={strings.propertyListing}
        titleactive={strings.editProperty}
        isBackBtn={true}
      />
      <div className="container-fluid">
        <div className="row ">
          <div className="col-sm-12 ">
            <div className="card">
              <div className="card-header pb-0">
                <h5>{strings.editproperty}</h5>
              </div>
              <form className="form theme-form">
                <div className="card-body">
                  <div className="row align-items-center">
                    <div className="col">
                      <div className="">
                        <label htmlFor="exampleInputMobileNo">
                          {strings.content}
                        </label>
                      </div>
                      {propertyDoc && propertyDoc.length > 0 ? (
                        <>
                          {propertyDoc.filter(
                            (item) => item.document_type === "image"
                          ).length > 0 && (
                              <div className=" col-md-12">
                                <label
                                  htmlFor="exampleInputMobileNo"
                                  className="boldText"
                                >
                                  {strings.images}
                                </label>
                                <div className="row">
                                  {propertyDoc
                                    ? propertyDoc?.map(
                                      (item, index) =>
                                        item.document_type === "image" && (
                                          <Gallery
                                            key={index}
                                            withDownloadButton
                                          >
                                            <Item
                                              original={
                                                formState.base_url +
                                                item.document
                                              }
                                              thumbnail={
                                                formState.base_url +
                                                "/" +
                                                item.document
                                              }
                                              width="1024"
                                              height="768"
                                            >
                                              {({ ref, open }) => (
                                                <figure
                                                  className="col-md-1"
                                                  itemProp="associatedMedia"
                                                  itemScope=""
                                                >
                                                  <div
                                                    ref={ref}
                                                    onClick={open}
                                                    style={{
                                                      backgroundImage: `url(${formState.base_url}${item.document})`,
                                                      width: 48,
                                                      height: 42,
                                                      cursor: "pointer",
                                                      position: "relative",
                                                      backgroundSize: "cover",
                                                      backgroundPosition: "50%",
                                                      backgroundRepeat:
                                                        "no-repeat",
                                                      border: "1px solid black",
                                                    }}
                                                  ></div>
                                                  <div className="remove_image_icon">
                                                    <i
                                                      className="fa fa-times text-danger"
                                                      aria-hidden="true"
                                                      data-toggle="modal"
                                                      data-original-title="test"
                                                      data-target="#exampleModal1"
                                                      onClick={() =>
                                                        setDocType({
                                                          type: "image",
                                                          documentId:
                                                            item?.document,
                                                        })
                                                      }
                                                    ></i>
                                                  </div>
                                                </figure>
                                              )}
                                            </Item>
                                          </Gallery>
                                        )
                                    )
                                    : null}
                                </div>
                                <hr />
                              </div>
                            )}
                          {propertyDoc &&
                            propertyDoc?.filter(
                              (item) => item.document_type === "video"
                            ).length > 0 && (
                              <div className="col-md-12 align-items-center">
                                <label
                                  htmlFor="exampleInputMobileNo"
                                  className="boldText"
                                >
                                  {strings.videos}
                                </label>
                                <div className="row">
                                  {propertyDoc
                                    ?.filter(
                                      (item) => item.document_type === "video"
                                    )
                                    .map((item, i) => (
                                      <div key={i} className="col-md-1">
                                        <img
                                          src={
                                            formState.base_url +
                                            item.video_thumbnail
                                          }
                                          className="img-thumbnail"
                                          style={{
                                            width: 80,
                                            height: 50,
                                            cursor: "pointer",
                                            position: "relative",
                                          }}
                                        />
                                        <i
                                          className="fa fa-play theme-fa-icon"
                                          style={{
                                            position: "absolute",
                                            right: "32px",
                                            top: "18px",
                                            cursor: "pointer",
                                            color: "#fff",
                                            fontSize: "14px",
                                          }}
                                          data-toggle="modal"
                                          data-original-title="test"
                                          data-target="#exampleModal"
                                          onClick={() => {
                                            item.base_url = formState.base_url;
                                            setVideoDetails(item)
                                          }}
                                        ></i>
                                        <div className="remove_video_icon">
                                          <i
                                            className="fa fa-times text-danger"
                                            aria-hidden="true"
                                            data-toggle="modal"
                                            data-original-title="test"
                                            data-target="#exampleModal1"
                                            onClick={() =>
                                              setDocType({
                                                type: "video",
                                                documentId: item?.document,
                                              })
                                            }
                                          ></i>
                                        </div>
                                      </div>
                                    )) || null}
                                </div>
                                <hr />
                              </div>
                            )}

                          <div className=" col-md-3 align-items-center"></div>
                          {propertyDoc &&
                            propertyDoc.filter(
                              (item) => item.document_type === "document"
                            ).length > 0 && (
                              <div className=" col-md-12 align-items-center mt-2">
                                <label
                                  htmlFor="exampleInputMobileNo"
                                  className="boldText"
                                >
                                  {strings.catalogue}
                                </label>

                                <div className="row">
                                  {(propertyDoc &&
                                    propertyDoc
                                      .filter(
                                        (item) =>
                                          item.document_type === "document"
                                      )
                                      .map((item, index) => (
                                        <div key={index} className="col-md-1">
                                          <a
                                            href={
                                              formState.base_url + item.document
                                            }
                                            target={"_blank"}
                                          >
                                            <img
                                              src="/assets/images/documentIcon.png"
                                              className="img-fluid view_pro"
                                              style={{
                                                height: "30px",
                                                width: "30px",
                                              }}
                                            />
                                          </a>
                                          <div className="remove_doc_icon">
                                            <i
                                              className="fa fa-times text-danger"
                                              aria-hidden="true"
                                              data-toggle="modal"
                                              data-original-title="test"
                                              data-target="#exampleModal1"
                                              onClick={() =>
                                                setDocType({
                                                  type: "document",
                                                  documentId: item?.document,
                                                })
                                              }
                                            ></i>
                                          </div>
                                        </div>
                                      ))) ||
                                    null}
                                </div>
                                <hr />
                              </div>
                            )}
                        </>
                      ) : null}
                      <div className="row mb-3">
                        {uploadFields &&
                          uploadFields.map((input, index) => {
                            return (
                              <div className="row col-md-11" key={index}>
                                <div className="col-md-9 mt-1">
                                  <input
                                    className="form-control"
                                    type="file"
                                    name="property_image"
                                    // value={input?.file}
                                    onChange={(event) => {
                                      const validFile =
                                        ValidateExtensionImgeVideo(
                                          event.target
                                        );
                                      let data = [...uploadFields];
                                      if (validFile === true) {
                                        data[index]["file"] =
                                          event.target.files;
                                        data[index]["validMedia"] = null;

                                        setUploadFields(data);
                                        setFormVaild({
                                          ...formVaild,
                                          property_image: null,
                                        });
                                      } else {
                                        data[index]["file"] = "";
                                        data[index]["validMedia"] = validFile;
                                        setUploadFields(data);
                                      }
                                    }}
                                  />
                                  {formVaild.uploadFields && index === 0 && (
                                    <span style={{ color: "red" }}>
                                      {formVaild.uploadFields}
                                    </span>
                                  )}
                                  {input.validMedia &&
                                    String(input.file) === "" && (
                                      <span style={{ color: "red" }}>
                                        {input.validMedia}
                                      </span>
                                    )}
                                </div>
                                {index != 0 && (
                                  <div className="col-md-1 mt-1">
                                    <Button
                                      style={{ marginTop: "2px" }}
                                      className="btn btn-danger"
                                      onClick={() => removeFields(index)}
                                      label={"-"}
                                    ></Button>
                                  </div>
                                )}
                              </div>
                            );
                          })}
                        <div className="col-md-1">
                          <Button
                            style={{ marginTop: "4px" }}
                            className="btn btn-success "
                            onClick={addUploadFields}
                            label={"+"}
                          ></Button>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/*  */}
                  <div className="row align-items-center">
                    <div className="col">
                      <label htmlFor="exampleFormControlSelect9">
                        {strings.addCompetitorProperty}
                        {/* <span className="required-field"></span> */}
                      </label>

                      <div className="row mb-3">
                        {propertyFields &&
                          propertyFields.map((property, index) => {
                            return (
                              <div className="col-md-11 row" key={index}>
                                <div className="col-md-9 mt-1">
                                  <input
                                    disabled
                                    className="form-control"
                                    id="exampleFormControlFirstName"
                                    type="text"
                                    placeholder={strings.propertyName}
                                    name="property_name"
                                    value={property.property_name}
                                    onChange={(event) =>
                                      PropertyhandleChange(index, event)
                                    }
                                  />
                                  {/* {formVaild.property_name && index === 0 && (
                                    <span style={{ color: "red" }}>
                                      {formVaild.property_name}
                                    </span>
                                  )} */}
                                </div>
                                {/* {index != 0 && (
                                  <div className="col-md-1 mt-1">
                                    <Button
                                      style={{ marginTop: "2px" }}
                                      className="btn btn-danger"
                                      onClick={() =>
                                        removePropertyFields(index)
                                      }
                                      label={"-"}
                                    ></Button>
                                  </div>
                                )} */}
                              </div>
                            );
                          })}
                        {/* <div className="col-md-1">
                          <Button
                            style={{ marginTop: "5px" }}
                            className="btn btn-success"
                            onClick={addPropertyFields}
                            label={"+"}
                          ></Button>
                        </div> */}
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlSelect9">
                          {strings.leadFollowup}
                          {/* <span className="required-field"></span> */}
                        </label>

                        <select
                          disabled
                          className="form-control digits"
                          id="exampleFormControlSelect9"
                          name="lead_followup"
                          value={formState.lead_followup}
                          onChange={handleInputField}
                        >
                          <option value="">
                            {strings.selectlead}
                          </option>
                          {leadFollowUp.length > 0 ? (
                            leadFollowUp.map((item, index) => (
                              <option key={index} value={item._id}>
                                {item.title}
                              </option>
                            ))
                          ) : (
                            <option>{strings.Loading}</option>
                          )}
                        </select>
                        {/* {formVaild.lead_followup && (
                          <span style={{ color: "red" }}>
                            {formVaild.lead_followup}
                          </span>
                        )} */}
                      </div>
                    </div>
                  </div>

                  <div className="row row-margin pt-2">
                    <div className="col-md-8">
                      <div className="form-group">
                        <label htmlFor="exampleFormControlSelect9">
                          {strings.propertyAllocation}
                          {" (One required)"}
                          <span className="required-field"></span>
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    {propertyAllocation &&
                      propertyAllocation.map((select, index) => {
                        return (
                          (rolesList.some((i) => i._id === select.role_id) ||
                            select.role_id === "" ||
                            select.selectedUsers.length === 0) && (
                            <div className="col-md-11 row" key={index}>
                              <div className="col-md-5">
                                <div className="mb-3">
                                  <select
                                    disabled
                                    className="form-control digits"
                                    id="exampleFormControlSelect9"
                                    value={select.role_id}
                                    name="role_id"
                                    onChange={(event) =>
                                      handleChangeAllocation(index, event)
                                    }
                                  >
                                    <option value="">
                                      {strings.selectRole}
                                    </option>
                                    {rolesList &&
                                      rolesList.map((item, index) => {
                                        let isSourcingTL =
                                          propertyAllocation.some(
                                            ({ role_id }) =>
                                              role_id === SourcingTL
                                          )
                                            ? true
                                            : item._id !== SourcingManager;
                                        let isClosingTL =
                                          propertyAllocation.some(
                                            ({ role_id }) =>
                                              role_id === ClosingTL
                                          )
                                            ? true
                                            : item._id !== ClosingManager;
                                        return (
                                          isSourcingTL &&
                                          isClosingTL && (
                                            <option
                                              key={index}
                                              value={item._id}
                                              disabled={propertyAllocation.some(
                                                ({ role_id }) =>
                                                  role_id === item._id
                                              )}
                                            >
                                              {item.role_title}
                                            </option>
                                          )
                                        );
                                      })}
                                  </select>
                                  {formVaild.selectRole && index === 0 && (
                                    <span style={{ color: "red" }}>
                                      {formVaild.selectRole}
                                    </span>
                                  )}
                                </div>
                              </div>
                              <div className="col-md-4">
                                <div className="mb-3">
                                  <Select
                                    isDisabled
                                    isSearchable
                                    isMulti
                                    placeholder={strings.selectUser}
                                    isClearable
                                    options={
                                      select.role_id === SourcingManager ||
                                        select.role_id === ClosingManager
                                        ? ParentUserList.filter(
                                          (i) => i.role_id === select.role_id
                                        )
                                        : userList.filter(
                                          (i) => i.role_id === select.role_id
                                        )
                                    }
                                    getOptionLabel={(option) =>
                                      `${option.user_name}`
                                    }
                                    getOptionValue={(option) => option._id}
                                    styles={{
                                      container: (provided, state) => ({
                                        ...provided,
                                      }),
                                    }}
                                    name="selectedUsers"
                                    value={select.selectedUsers}
                                    onChange={(val) =>
                                      handleSelectMultiAllocation(index, val)
                                    }
                                  />
                                  {formVaild.selectUser && index === 0 && (
                                    <span style={{ color: "red" }}>
                                      {formVaild.selectUser}
                                    </span>
                                  )}
                                </div>
                              </div>

                              {/* {index != 0 && (
                                <div className="col-md-1">
                                  <Button
                                    className="btn btn-danger"
                                    onClick={() => removeField(index)}
                                    label={"-"}
                                  ></Button>
                                </div>
                              )} */}
                            </div>
                          )
                        );
                      })}
                    {/* <div className="col-md-1">
                      <Button
                        className="btn btn-success"
                        onClick={addSelectFields}
                        disabled={allocationAddMore}
                        label={"+"}
                      ></Button>
                    </div> */}
                  </div>

                  <div className="row row-margin">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlSelect9">
                          {strings.insentive}
                          {" (One required)"}
                          {/* <span className="required-field"></span> */}
                        </label>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    {insetiveState &&
                      insetiveState.map((select, index) => {
                        return (
                          <div className="col-md-11 row" key={index}>
                            <div className="col-md-5">
                              <div className="mb-3">

                                <select
                                  disabled
                                  className="form-control digits"
                                  id="exampleFormControlSelect9"
                                  value={select.insentive_type_id}
                                  name="insentive_type_id"
                                  onChange={(event) =>
                                    handleInsetiveState(index, event)
                                  }
                                >
                                  <option value="">
                                    {strings.selectType}
                                  </option>
                                  {insentiveTypes.length > 0 ? (
                                    insentiveTypes.map((item, index) => (
                                      <option
                                        key={index}
                                        value={item._id}
                                        disabled={insetiveState.some(
                                          ({ insentive_type_id }) =>
                                            insentive_type_id === item._id
                                        )}
                                      >
                                        {item.title}
                                      </option>
                                    ))
                                  ) : (
                                    <option>{strings.Loading}</option>
                                  )}
                                </select>
                                {/* {formVaild.insentive_type_id && index === 0 && (
                                  <span style={{ color: "red" }}>
                                    {formVaild.insentive_type_id}
                                  </span>
                                )} */}
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="mb-3">
                                <input
                                  disabled
                                  className="form-control"
                                  id="exampleFormControlFirstName"
                                  autoComplete="off"
                                  type="number"
                                  name="amount"
                                  value={select.amount}
                                  placeholder={strings.amount}
                                  onChange={(event) =>
                                    handleInsetiveState(index, event)
                                  }
                                  onKeyPress={(e) => {
                                    if (e.target.value.length >= 10) {
                                      e.preventDefault();
                                    }
                                  }}
                                />
                                {/* {formVaild.amount && index === 0 && (
                                  <span style={{ color: "red" }}>
                                    {formVaild.amount}
                                  </span>
                                )} */}
                              </div>
                            </div>

                            {/* {index != 0 && (
                              <div className="col-md-1">
                                <Button
                                  className="btn btn-danger"
                                  onClick={() => removeInsentive(index)}
                                  label={"-"}
                                ></Button>
                              </div>
                            )} */}
                          </div>
                        );
                      })}
                    {/* <div className="col-md-1">
                      <Button
                        className="btn btn-success"
                        onClick={addInsetiveState}
                        label={"+"}
                      ></Button>
                    </div> */}
                  </div>

                  <div className="row pt-3">
                    <div className="col-md-8">
                      <div>
                        <label htmlFor="exampleFormControlLastName">
                          {strings.pickupAllowed} (Optional)
                        </label>
                        <div className="col">
                          <div className="form-group m-t-15 m-checkbox-inline mb-0 custom-radio-ml">
                            <div className="radio radio-primary ">
                              <input
                                disabled
                                id="radioinline4"
                                type="radio"
                                name="pickup"
                                value={"Yes"}
                                checked={
                                  formState.pickup === "Yes" ? true : false
                                }
                                onChange={handleInputField}
                              />
                              <label className="mb-0" for="radioinline4">
                                {strings.yes}
                              </label>
                            </div>
                            <div className="radio radio-primary mr-5 ml-4">
                              <input
                                disabled
                                id="radioinline5"
                                type="radio"
                                name="pickup"
                                value={"No"}
                                checked={
                                  formState.pickup === "No" ? true : false
                                }
                                onChange={handleInputField}
                              />
                              <label className="mb-0" for="radioinline5">
                                {strings.no}
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
                <div className="row">
                  <div className="col-md-12 d-flex justify-content-end">
                    <div className="card-footer">
                      <Button
                        className="btn btn-color"
                        type="Button"
                        onClick={() => handleSubmit()}
                        label={strings.next}
                      ></Button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default EditPropertyNext;
